
import { defineComponent, SetupContext, ref, computed } from "vue";
import NativeClient from "@/client/native-client";
import {
  PLATE_DISPLAY_FORMAT,
  PANTRY_FOOD_TYPE,
  PlateInfoData,
  ERROR_STATUS_CODE_SUCCESS,
  ALL_TIME_CONNECT_MODE
} from "@/types/pantry";

export default defineComponent({
  name: "PantryDetailTitleView",
  components: {},
  props: {
    type: {
      type: String,
      defalut: ""
    },
    stock: {
      type: String,
      default: ""
    },
    imageUrl: {
      type: String,
      defalut: ""
    },
    name: {
      type: String,
      defalut: ""
    },
    plateName: {
      type: String,
      defalut: null
    },
    showLowBattery: {
      type: Boolean,
      default: false
    },
    data: {
      type: PlateInfoData,
      default: null,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const loadError = ref(false);
    const isShowImage = () => {
      if (loadError.value) {
        return false;
      }
      if (props.imageUrl) {
        return true;
      }
      return false;
    };
    const onImageError = (event: Event) => {
      NativeClient.sendDebugLog("PantryDetailTitleView onImageError");
      if (event.target) {
        loadError.value = true;
      }
    };
    const styleBackgroundImage = computed(() => {
      let result = "none";
      if (props.data && props.data.data && props.data.data.unit) {
        const plate = props.data.data;
        const value = plate.item != null ? plate.item.value : 0;
        let barValue = 0;
        if (plate.unit.displayFormat == PLATE_DISPLAY_FORMAT.VALUE) {
          barValue =
            (plate.unit.unitWeight * value * 100) / plate.unit.fullWeight;
        } else {
          barValue = value;
        }
        if (barValue >= 100) {
          // Android端末で100の場合に隙間ができる現象の対応
          barValue = 101;
        }
        const barPersent = barValue + "%";
        NativeClient.sendDebugLog(
          "PantryDetailTitleView styleBackgroundImage barValue=" + barValue
        );
        result =
          "radial-gradient(#ffffff 60%, transparent 30%), conic-gradient(var(--main-thinline-color) 0% " +
          barPersent +
          ", #dddddd " +
          barPersent +
          " 100%)";
        NativeClient.sendDebugLog(
          "PantryDetailTitleView styleBackgroundImage result=" + result
        );
      }
      return result;
    });
    const getName = () => {
      let name = props.name ? props.name : "";
      if (name.length > 8) {
        name = name.substring(0, 7) + "...";
      }
      return name;
    };
    const isShowPlateUpdate = () => {
      let result = false;
      if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        result = true;
      }
      return result;
    };

    const isEnablePlateUpdate = () => {
      let result = false;
      if (props.type == PANTRY_FOOD_TYPE.PLATE) {
       if (
          props.data &&
          props.data.data &&
          (props.data.data.errorStatus == null ||
            (props.data.data.errorStatus &&
              props.data.data.errorStatus.errorCode ==
                ERROR_STATUS_CODE_SUCCESS))
        ) {
          NativeClient.sendDebugLog("isEnablePlateUpdate plate=" + JSON.stringify(props.data.plate));
          if (props.data.plate) {
            result = (props.data.plate.internalMode == ALL_TIME_CONNECT_MODE);
          }
          NativeClient.sendDebugLog("isEnablePlateUpdate result=" + JSON.stringify(result));
        }
      }
      return result;
    };
    const clickUpdatePlate = () => {
      NativeClient.sendDebugLog("clickUpdatePlate");
      const result = isEnablePlateUpdate();
      if (!result) {
        return;
      }
      context.emit("click-update-plate");
    };
    const styleUpdateButtonBackground = computed(() => {
      const isEnable = isEnablePlateUpdate();
      NativeClient.sendDebugLog("styleUpdateButtonBackground isEnable=" + isEnable);
      return isEnable ? "#333333" : "#CDCDCD";
    });
    return {
      isShowImage,
      onImageError,
      getName,
      styleBackgroundImage,
      PANTRY_FOOD_TYPE,
      isShowPlateUpdate,
      clickUpdatePlate,
      styleUpdateButtonBackground
    };
  }
});
